export enum Langage {
  fr = 'fr',
  en = 'en',
}
